import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import paths from 'routes/paths';
import { isCaregiverRole } from 'helpers/isSharedLivingActive';

/**
 * UI-052: shown when a user lands on a page they are not authorized to view.
 * SharedLiving caregivers (role 7) are routed back to My Patients; everyone
 * else back to the dashboard.
 */
const AccessDenied = () => {
  const caregiver = isCaregiverRole();
  const backTo = caregiver ? paths.caregiverMyPatients : '/main';
  const backLabel = caregiver ? 'Back to My Patients' : 'Take me home';

  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">403</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
          You don't have access to this page.
        </p>
        <hr />
        <p>
          Your account isn't permitted to view this section. If you believe this
          is a mistake, please contact your administrator.
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to={backTo}>
          <FontAwesomeIcon icon={faHome} className="me-2" />
          {backLabel}
        </Link>
      </Card.Body>
    </Card>
  );
};

export default AccessDenied;
